import { HttpWrapperService, ContextRoot } from '@util-services';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiServiceAbstract {
  protected readonly contextRoot: string;
  protected readonly sectorCode: string;

  constructor(protected readonly httpWrapper: HttpWrapperService) {
    this.contextRoot = ContextRoot;
  }
}
